import { render, staticRenderFns } from "./DashboardWochitStoryboards.vue?vue&type=template&id=2147ae65&scoped=true&"
import script from "./DashboardWochitStoryboards.vue?vue&type=script&lang=js&"
export * from "./DashboardWochitStoryboards.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWochitStoryboards.vue?vue&type=style&index=0&id=2147ae65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147ae65",
  null
  
)

export default component.exports